import { createAction } from '../../store.model';
import { ActionType } from '../my-performance-card.action';
export interface TogglePillarCollapseAction {
    id: string;
    metricId: number;
    userId: number;
}
export const togglePillarCollapseAction = createAction<
    ActionType,
    TogglePillarCollapseAction
>(ActionType.MY_PERFORMANCE_CARD_TOGGLE_PILLAR_COLLAPSE);
